import { Link } from '@apollo/orbit';
import { Astronaut1 } from '@apollo/space-kit/illustrations/Astronaut1';
import React from 'react';

import { variantSettingsRouteConfig } from 'src/app/graph/routes';
import { useLDFlag } from 'src/lib/launchDarkly';
import { DocsRouter } from 'src/lib/routers';

export const NoOperationsToCheckAgainstContent = ({
  failedStaticCheck,
  hasUsageData,
  hasChanges,
  graphId,
  graphVariant,
}: {
  failedStaticCheck: boolean;
  hasUsageData: boolean;
  hasChanges: boolean;
  graphId?: string;
  graphVariant?: string;
}) => {
  const shouldShowConfigText = useLDFlag('pulsar-show-downgrade-checks-config');

  const configLink =
    graphId && graphVariant ? (
      <>
        {' '}
        <Link
          to={variantSettingsRouteConfig.location({
            tab: 'checks_operations',
            graphId,
            graphVariant,
          })}
        >
          here
        </Link>
      </>
    ) : (
      ''
    );

  return (
    <div className="mx-auto flex max-w-lg flex-1 items-center justify-center">
      <div>
        <Astronaut1 className="mx-auto mb-6 block" />
        <div className="text-heading-xl mb-6 text-center">
          {!hasChanges ? (
            <>No changes detected</>
          ) : failedStaticCheck ? (
            <>Potentially breaking changes detected</>
          ) : (
            <>No operations found</>
          )}
        </div>
        <div className="text-body mb-6 text-center">
          {!hasChanges ? (
            <>
              The schema you checked against is identical to your registered
              schema.
            </>
          ) : (
            <>
              {!hasUsageData ? (
                <>
                  We were not able to find usage data for any operations on this
                  variant. Your local schema changes were not checked against
                  any operations.
                </>
              ) : (
                <>
                  No operations were checked. This could be because you have no
                  recent usage data on this variant, or your check configuration
                  is excluding all operations.
                </>
              )}
              <br />
              <br />
              To set up usage reporting visit{' '}
              <Link isExternal to={DocsRouter.path('UsageReporting')}>
                the Apollo Studio docs
              </Link>
              .{' '}
              {failedStaticCheck ? (
                <>
                  Learn more about potentially breaking changes{' '}
                  <Link
                    isExternal
                    to={DocsRouter.path(
                      'SchemaValidationPotentiallyBreakingChanges',
                    )}
                  >
                    here
                  </Link>
                  .
                </>
              ) : (
                ''
              )}
              {shouldShowConfigText ? (
                <>
                  {' '}
                  If you would like the operation check to{' '}
                  {failedStaticCheck ? 'pass' : 'fail'} instead of{' '}
                  {failedStaticCheck ? 'fail' : 'pass'} in this case, turn{' '}
                  {failedStaticCheck ? 'on' : 'off'} the "Ignore breaking
                  changes if there are no operations" configuration option{' '}
                  {configLink}.
                </>
              ) : (
                ''
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
